import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spin } from 'antd';
import { useDispatch } from 'react-redux';
import { setUser } from '../store/slices/authSlice';

/**
 * OAuth Callback Handler Component
 * Handles the redirect from backend OAuth callback
 * Extracts token and user info from URL query params and stores them
 *
 * IMPORTANT: Only processes if there's a token AND user is not already authenticated
 */
const OAuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const token = searchParams.get('token');
    const email = searchParams.get('email');
    const name = searchParams.get('name');
    const picture = searchParams.get('picture');
    const role = searchParams.get('role');
    const isAdmin = searchParams.get('is_admin') === 'true';

    // Only process if we have a token from OAuth callback
    if (token && email) {
      // Save to localStorage (use consistent key 'token')
      localStorage.setItem('token', token);

      const user = {
        email,
        name,
        picture,
        role: role || (isAdmin ? 'admin' : 'user'),
        is_admin: isAdmin
      };

      localStorage.setItem('user', JSON.stringify(user));

      // Update Redux store
      dispatch(setUser({ user, token, isAuthenticated: true }));

      // Remove query params from URL and navigate to clean URL
      const currentPath = window.location.pathname;

      // Use setTimeout to ensure state is updated before navigation
      setTimeout(() => {
        navigate(currentPath, { replace: true });
      }, 100);
    } else {
      // No OAuth params, not processing
      setProcessing(false);
    }
  }, [searchParams, dispatch, navigate]);

  // Only show loading if we're actually processing OAuth callback
  if (processing && searchParams.get('token')) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <Spin size="large" tip="Authenticating..." />
      </div>
    );
  }

  // If not processing, return null (let the route render)
  return null;
};

export default OAuthCallback;
